export default {
  common: {
    brand: 'USFans Spreadsheet',
    nav: {
      home: 'Accueil',
      categories: 'Catégories',
      guides: 'Guides',
      shoppingGuide: 'Guide d’achat',
      safety: 'Sécurité',
      faq: 'FAQ',
    },
    cta: {
      spreadsheet: 'usfans spreadsheet',
      buyNow: 'buy it now',
      explore: 'Explorer USFans Spreadsheet',
      browseDirectory: 'Parcourir le répertoire',
    },
    search: {
      placeholder: 'Rechercher USFans Spreadsheet, produits, catégories ou guides…',
    },
    language: 'Langue',
    footer: {
      tagline: 'Un centre de ressources indépendant qui vous aide à trouver, comparer et explorer les ressources USFans Spreadsheet : organisé, actualisé et multilingue.',
      resources: 'Ressources',
      resourcesGuides: 'Guides',
      resourcesCategories: 'Catégories',
      resourcesSafety: 'Guide de sécurité',
      resourcesFaq: 'FAQ',
      company: 'Entreprise',
      about: 'À propos',
      editorialPolicy: 'Politique éditoriale',
      contact: 'Contact',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions',
      disclaimer: 'Avertissement',
      rights: 'Tous droits réservés.',
    },
    languages: {
      en: 'English',
      pl: 'Polski',
      es: 'Español',
      fr: 'Français',
    },
  },
};